/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErpProvisioningRequestPostSpec { 
    saasTransactionID: string;
    action?: string;
    sku?: string;
    serialNumber?: string;
    quantity?: string;
    subscriptionType?: string;
    pla?: string;
    serviceStartDate?: string;
    serviceEndDate?: string;
    erpCustAcctNumber?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    countryCode?: string;
    newTenantRequired?: string;
    tenantID?: string;
    information?: string;
}

